/**
 * Grid Generator — namespaced Vuex store module.
 *
 * Migrated from the standalone efficient-vineyard-grid-generator plugin.
 * The plugin's original `new Vuex.Store(...)` becomes a namespaced module
 * so the ~1,700 lines of grid logic in actions.js (including the
 * box-sampling protocol) carry over essentially verbatim — inside a
 * namespaced module, an action's `state` / `commit` / `dispatch` are
 * already scoped to the module.
 *
 * GridGenerator.vue registers this module on entry and unregisters it on
 * leave, so each visit starts from clean state.
 */
import actions from './actions.js'
import mutations from './mutations.js'

export default {
  namespaced: true,
  state: () => ({
    alert: {
      active: false,
      message: 'This is a basic alert',
      level: 'alert-info'
    },
    avoidEdges: false,
    blocksGeoJson: {},
    breadcrumbs: [
      { id: 'root', name: 'Root' }
    ],
    datasets: [],
    dataset: {},
    datasetGeoJson: {},
    datasetHeader: false,
    distributionModel: 'random',
    folders: [],
    folder: { id: 'root', name: 'Root' },
    download: {},
    farm: {},
    datasetModel: 'nonStratified',
    intervalCount: 10,
    gridCount: 25,
    gridDistance: 3,
    gridDistributedBy: 'distance',
    gridGeoJson: {},
    gridType: 'dataset',
    limit: 10,
    lastVisibleDataset: {},
    loadingMore: false,
    loadingDataset: false,
    loader: false,
    loaderValue: 0,
    loaderMax: 100,
    mapObject: {},
    paginate: false,
    pointsPerZone: 5,
    post: { name: 'Grid' },
    posting: false,
    sortBy: 'Most Recent',
    selectedBlocks: [],
    // Sample area loaded from a polygon dataset (e.g. drone-derived row
    // masks): { id, name, count } when active, false otherwise. Its
    // features live inside selectedBlocks tagged properties.areaDataset.
    areaDataset: false,
    loadingAreaDataset: false,
    spinner: false,
    boxSamplingWindowSize: 3,
    minPixelsPerZone: 1
  }),
  actions,
  mutations
}
